import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { connect } from 'react-redux';
import InputField from '../InputField';
import WaypointIcons from '../WaypointIcons';

const PlacePropTypes = {
  glyph: PropTypes.string.isRequired, // Icon to display beside the input field
  defaultText: PropTypes.string, // Input placeholder text
  name: PropTypes.string.isRequired, // Input name used to identify input
  value: PropTypes.string.isRequired, // Value of the input field
  handleChange: PropTypes.func.isRequired, // Method to invoke when input value changes
  last: PropTypes.bool, // If this is the last rendered component in a list of input fields
  index: PropTypes.number.isRequired, // For identifying the input element
  isMobile: PropTypes.bool.isRequired, // True when the app is loaded on a handheld sized device
  directionsLoaded: PropTypes.bool.isRequired, // If the directions have successfully returned from API
  handleKeyPress: PropTypes.func.isRequired, // Listens for keyup and keydown events
  handleFocus: PropTypes.func.isRequired, // Lets the app know which field is currently focused
  handleBlur: PropTypes.func.isRequired, // When the input field loses focus
  shortAddress: PropTypes.string, // Short version of address for mobile devices
  editing: PropTypes.bool.isRequired, // If the route is being edited
};

const PlaceDefaultProps = {
  defaultText: null,
  last: true,
  shortAddress: '',
};

// eslint-disable-next-line arrow-parens
export const Place = props => {
  // eslint-disable-next-line object-curly-newline
  const { value, isMobile, directionsLoaded, editing, shortAddress } = props;
  const address = isMobile && !editing ? shortAddress : value;

  return (
    <div
      className={classNames('form-item tsla-form-item--map', {
        'tsla-form-item--mobile': isMobile && directionsLoaded,
      })}
    >
      <div
        className={classNames('form-label tsla-form-label--map', {
          'tsla-form-label--mobile': isMobile && directionsLoaded,
        })}
      >
        <WaypointIcons {...props} />
        <InputField {...props} />
        {isMobile && directionsLoaded && <b>{address}</b>}
      </div>
    </div>
  );
};

Place.propTypes = PlacePropTypes;

Place.defaultProps = PlaceDefaultProps;

const mapStateToProps = state => ({
  isMobile: state.App.isMobile,
  directionsLoaded: state.Directions.directionsLoaded,
  editing: state.Places.editing,
});

export default connect(
  mapStateToProps,
  null,
)(Place);
